module.exports = __webpack_public_path__ + "static/media/LogoDE.6b13e4d7.svg";